import { motion } from "framer-motion";
import SceneShell from "../components/SceneShell";
import StaggerText from "../components/StaggerText";

/**
 * Scene 07 — The line. "Video isn't growing… It's dominating."
 */
export default function Scene07_VideoDominates() {
  return (
    <SceneShell variant="ink" align="left" data-testid="scene-video-dominates">
      {/* Slow ambient drift */}
      <motion.div
        className="absolute -top-40 -left-20 w-[700px] h-[700px] rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(150,193,31,0.18) 0%, transparent 60%)",
          filter: "blur(50px)",
        }}
        animate={{ x: [0, 60, 0], y: [0, -40, 0] }}
        transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute -bottom-40 -right-20 w-[700px] h-[700px] rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(0,222,182,0.14) 0%, transparent 60%)",
          filter: "blur(50px)",
        }}
        animate={{ x: [0, -50, 0], y: [0, 40, 0] }}
        transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="relative max-w-[1600px] mx-auto w-full">
        <StaggerText
          as="h2"
          text="Video isn't growing…"
          className="kn-display text-[40px] sm:text-[64px] lg:text-[96px] text-white/85 leading-[0.95]"
          stagger={0.08}
          delay={0.3}
          data-testid="dominates-line-1"
        />

        <motion.h2
          initial={{ opacity: 0, y: 40, filter: "blur(12px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{ duration: 1.2, delay: 1.4, ease: [0.16, 1, 0.3, 1] }}
          className="kn-display text-[44px] sm:text-[80px] lg:text-[120px] leading-[1.1] mt-3 pb-2"
          style={{
            background: "linear-gradient(135deg, #96C11F 0%, #00deb6 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
            textShadow: "0 0 80px rgba(150,193,31,0.25)",
          }}
          data-testid="dominates-line-2"
        >
          It's dominating.
        </motion.h2>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.9, delay: 2.6 }}
          className="mt-16 inline-flex items-center gap-3"
        >
          <span
            className="w-12 h-px"
            style={{ background: "#96C11F" }}
          />
          <span className="text-sm text-white/65 tracking-[0.32em] uppercase">
            Every screen · every feed · every demographic
          </span>
        </motion.div>
      </div>
    </SceneShell>
  );
}
